export const GET_WORK_DETAILS = "GET_WORK_DETAILS";
export const GET_WORK_DETAILS_RESPONSE = "GET_WORK_DETAILS_RESPONSE";
export const GET_WORK_DETAILS_FAIL = "GET_WORK_DETAILS_FAIL";

export const UPDATE_WORK_DETAILS = "UPDATE_WORK_DETAILS";
export const UPDATE_WORK_DETAILS_RESPONSE = "UPDATE_WORK_DETAILS_RESPONSE";
export const UPDATE_WORK_DETAILS_FAIL = "UPDATE_WORK_DETAILS_FAIL";